import * as PIXI from "pixi.js";
import { ISkeletonData, Spine } from "pixi-spine";
import { Scale, Safe, CreateSpineResources } from "./MyHelpers";
import { AtlasResource } from "./ResourceManager/AtlasResource";
import { JSONResource } from "./ResourceManager/JSONResource";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "./ResourceManager/ResourceManager";
import { JackpotDisplayType, Settings } from "./Settings";
import { text } from "svelte/internal";
import { service } from "./services";
import { JackpotLevel, Money, SharedJackpotWin } from "./api";
import { el } from "date-fns/locale";
import { JackpotProperties } from "./JackpotProperties";
import { AudioManager, Track } from "./AudioManager";


export const enableJackpotSharedMap : Record<JackpotDisplayType , boolean> = {
    [JackpotDisplayType.PreciousSpin]: false,
    [JackpotDisplayType.DiamondPot]: false,
    [JackpotDisplayType.DiamondPotOrtiz]: false,
    [JackpotDisplayType.DragonJackpot]: false,
    [JackpotDisplayType.DiamondPotStep]: false,
    [JackpotDisplayType.DiamondPotCaliente]: false,
    [JackpotDisplayType.DiamondPotPlayCity]: false,
    [JackpotDisplayType.PlayCityLink]: false,
    [JackpotDisplayType.JubileeLink]: false,
    [JackpotDisplayType.DiamondPotJubilee]: false,
    [JackpotDisplayType.PaytableJackpotDisplay]: false,
    [JackpotDisplayType.ViventoLink]: false,
    [JackpotDisplayType.RapidDiamondPot]: false,
    [JackpotDisplayType.RapidDiamondPot2]: false,
    [JackpotDisplayType.RapidDiamondPotStep]: false,
    [JackpotDisplayType.RapidDiamondPotFire]: false,
    [JackpotDisplayType.DiamondPotRappidFrames]: false,
    [JackpotDisplayType.DiamondPotStepRappidFrames]: false,
    [JackpotDisplayType.RapidDiamondPotStep2]: false,
    [JackpotDisplayType.RainbowGirls]: false,
    [JackpotDisplayType.DiamondPotStepShared]: false,
    [JackpotDisplayType.DiamondPotStepSinShared]: false,
    [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: false,
    [JackpotDisplayType.DiamondPotRappidFramesSpine]: false,
    [JackpotDisplayType.DiamondPotStepSharedSpineV2]: false,
    [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: false,
    [JackpotDisplayType.DiamondPotPyramidShared]: true,
    [JackpotDisplayType.DiamondPotPyramidSinShared]: true,
    [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: true,
    [JackpotDisplayType.DiamondPotPyramidShared2S]: true,
    [JackpotDisplayType.DiamondPotPyramidSinShared2S]: true,
    [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: true,
    [JackpotDisplayType.PlayCityLinkResponsive]: false,
    [JackpotDisplayType.PlayCityLinkResponsivePIXI]: false,
    [JackpotDisplayType.JubileeLinkResponsive]: false,
    [JackpotDisplayType.JubileeLinkResponsivePIXI]: false,
    [JackpotDisplayType.DiamondPotResponsive]: false,
    [JackpotDisplayType.DiamondPotResponsivePIXI]: false,
    [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]: false
}
interface IJackpotShowSharedElement
{
    jackpotElement : JackpotShowSharedElement;
    jackpotAssetSkeleton : ISkeletonData;
    colorString : string,
}

class JackpotShowSharedElement {
    constructor(){

    }

    protected spine : Spine = null;
    protected textView : PIXI.Text = null;
    public Create(assetJackpot : ISkeletonData , jackpotLevel : JackpotLevel , colorString : string){
        this.spine = CreateSpineResources(assetJackpot);
        this.spine.name = `JackPotSharedShow-${jackpotLevel}`;

        this.spine.position.y = Settings.ScreenHeight * (Settings.Screens - 1);
        
        //this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
        let containersChildersIntoSpineJP4 = this.spine.children as PIXI.Container[];
        containersChildersIntoSpineJP4.forEach((container) => {
            if (container.name == "JPContainerValue") {
                this.textView = new PIXI.Text(0,{
                    fontFamily: 'NotoSansDisplay-Bold',			
                    fontSize: 150,			
                    fontWeight: 'bold',
                    fill: [colorString], // gradient
                    stroke: 'white',
                    strokeThickness:  Scale.fh(8),			
                    //wordWrap: true,			
                    lineJoin: 'round',
                    //textBaseline : "middle",			
                });
                
                this.textView.anchor.set(0.5,0.5);
                this.textView.scale.y = -1;
               // textView.y = -200fit;
                //textView.position.set(Settings.ScreenWidth/2 ,  Settings.ScreenHeight/2 + 	(textView.height/2) );		

                container.addChild(this.textView);
                //this.containerSpinnableReelsSpine.updateTransform();
            }
        });
        this.spine.visible = false;

        return this.spine;
    }
    

    public Show(){
        this.spine.visible = true;
        if(this.spine.stateData.skeletonData.animations.find(anim => anim.name == "Win")) this.spine.state.setAnimation(0,"Win",false);
    }

    public Hide(){
        if(this.spine == null ) return 
        this.spine?.state?.clearTracks();
        this.spine.visible = false;
    }

    public Destroy(){
        Safe(() => this.spine.destroy({children: true, texture: false, baseTexture: true}))
        Safe(() =>this.spine.removeFromParent());   
        this.spine = null;
    }

    public GetDuration(){
        return this.spine.stateData.skeletonData.animations.find(anim => anim.name == "Win").duration * 1000 ;
    }

    public SetAward(award : number ){
        this.textView.text = service.moneyFormatter.FormatCurrency(award);
    }
}
export class JackpotSharedShow{

    protected view : PIXI.Container
    //protected resid : ResourceIdentifier
    protected audio : AudioManager = null;
    protected commonBonusResourcesBasePath : string = null;
    protected resid : ResourceIdentifier = null
    constructor( audio : AudioManager  , resid : ResourceIdentifier){
        this.audio = audio;
        this.commonBonusResourcesBasePath = Settings.ResourcesFolder + `multigame/slot/common/resources/tracks`;
        this.resid = resid.Add("JackpotSharedShow");
    }
    public async PrepareResources(resourceManager: IWriteOnlyResourceManager) {   
        for (const jackpotLevel of this.jackpotLevelsAvailable)
        {
           await resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotDisplay${Settings.JackpotDisplayType}/JackpotWinShare/${jackpotLevel}/JackpotWinShare.json`, ResourceIdentifier.Global.ScopedResourceName(`JackpotWinShowShare${jackpotLevel}-Json`)));
           await resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotDisplay${Settings.JackpotDisplayType}/JackpotWinShare/${jackpotLevel}/JackpotWinShare.atlas`, ResourceIdentifier.Global.ScopedResourceName(`JackpotWinShowShare${jackpotLevel}-Atlas`)));
        };
        

        this.audio.AddTrack(new Track(this.commonBonusResourcesBasePath + "/jpshared" + Settings.audioFormat,  this.resid.ScopedResourceName("jpsharedVoice") , true));
        
        //resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotDisplay${JackpotDisplayType.DiamondPotStepShared}/JackpotWinShare/${JackpotLevel.Jp3}/JackpotWinShare.json`, ResourceIdentifier.Global.ScopedResourceName(`JackpotWinShowShare${JackpotLevel.Jp3}-Json`)));
        //resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotDisplay${JackpotDisplayType.DiamondPotStepShared}/JackpotWinShare/${JackpotLevel.Jp3}/JackpotWinShare.atlas`, ResourceIdentifier.Global.ScopedResourceName(`JackpotWinShowShare${JackpotLevel.Jp3}-Atlas`)));        
    }
    
    //protected assetJackpot : ISkeletonData = null;
    protected jpSharedShow : Map<JackpotLevel,IJackpotShowSharedElement> = new Map<JackpotLevel,IJackpotShowSharedElement>();
    
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        for (const jackpotLevel of this.jackpotLevelsAvailable)
        {
            let jackpotWinShareShowJson = await resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`JackpotWinShowShare${jackpotLevel}-Json`));
            let jsonDataAssetLoad = await PIXI.Assets.load(jackpotWinShareShowJson.path).finally(()=>{
                PIXI.Assets.cache.remove(jackpotWinShareShowJson.path);
            });
            let assetJackpotJP = jsonDataAssetLoad.spineData
            //console.log(`AssetJackpotShare-${jackpotLevel}:`, assetJackpotJP);

            this.jpSharedShow.set(jackpotLevel, {
                jackpotAssetSkeleton: assetJackpotJP,
                jackpotElement: new JackpotShowSharedElement(),
                colorString: JackpotProperties[Settings.JackpotDisplayType][jackpotLevel].color,
            });
        }
    }

    public View() : PIXI.Container {
        return this.view;
    }
    
    protected showTimeIsStarted = false;
    public IsStarted(): boolean {
        return this.showTimeIsStarted;
    }
    protected jackpotLevelsAvailable: JackpotLevel[] = [JackpotLevel.Jp4, JackpotLevel.Jp4s, JackpotLevel.Jp3,JackpotLevel.Jp3s, JackpotLevel.Jp2, JackpotLevel.Jp1];
    protected debuggerWin : number []=[12405069,240000,100000,2000]
    protected indexDebbuger = 0;


    public ShowShared(win: SharedJackpotWin) {        
        if (this.showTimeIsStarted == true) return
        this.showTimeIsStarted = true;

        let jackpotShow = this.jpSharedShow.get(win.JackpotLevel);

        // if (jackpotLevel == null) {
        //     if (this.indexDebbuger == (this.jpSharedShow.size)) this.indexDebbuger = 0;
        //     jackpotShow = this.jpSharedShow.get(this.jackpotLevelsAvailable[this.indexDebbuger]);
        //     jackpotShow.jackpotElement.SetAward(this.debuggerWin[this.indexDebbuger]);
        // }
        jackpotShow.jackpotElement.SetAward(win.WinAmount.InCents);
        jackpotShow.jackpotElement.Show();
        if(win.JackpotLevel == JackpotLevel.Jp4s || win.JackpotLevel == JackpotLevel.Jp3s) this.audio.Play(this.resid.ScopedResourceName("jpsharedVoice"));
        setTimeout(() => {
            this.showTimeIsStarted = false;
            jackpotShow.jackpotElement.Hide();
            jackpotShow = null
            this.indexDebbuger++;
        }, jackpotShow.jackpotElement.GetDuration());
    }

    // public ShowNormalJackpot(jp : JackpotLevel , winAmount: Money) {        
    //     if (this.showTimeIsStarted == true) return
    //     this.showTimeIsStarted = true;

    //     let jackpotShow = this.jpSharedShow.get(jp);

        

    //     // if (jackpotLevel == null) {
    //     //     if (this.indexDebbuger == (this.jpSharedShow.size)) this.indexDebbuger = 0;
    //     //     jackpotShow = this.jpSharedShow.get(this.jackpotLevelsAvailable[this.indexDebbuger]);
    //     //     jackpotShow.jackpotElement.SetAward(this.debuggerWin[this.indexDebbuger]);
    //     // }
    //     jackpotShow.jackpotElement.SetAward(winAmount.InCents);
    //     jackpotShow.jackpotElement.Show();        
    //     setTimeout(() => {
    //         this.showTimeIsStarted = false;
    //         jackpotShow.jackpotElement.Hide();
    //         jackpotShow = null
    //         this.indexDebbuger++;
    //     }, jackpotShow.jackpotElement.GetDuration());
    // }

    public isVisible(){
        return this.showTimeIsStarted;
    }

    // public SetAward(jackpotLevel: JackpotLevel, award : number){        
    //     this.jpSharedShow.get(jackpotLevel).jackpotElement.SetAward(award);
    // }


    //protected spine : Spine = null;
    public Create(){        
        this.view = new PIXI.Container();
        this.view.interactive = false;
        this.view.name = "JackpotSharedShow-Container";
        this.jpSharedShow.forEach((ele , key) =>{
            let spine = ele.jackpotElement.Create(ele.jackpotAssetSkeleton,key,ele.colorString);
            this.view.addChild(spine);
        }); 
        this.indexDebbuger = 0;
    }

    public Destroy(){                        
        this.showTimeIsStarted = false;    
        this.jpSharedShow.forEach((ele , key) =>{
            Safe(() =>ele.jackpotElement.Destroy());
        }); 
        Safe(() =>this.view.destroy(true));
        this.view.removeFromParent();
        this.view = null;        
    }

    public GetDuration(jackpotLevel: JackpotLevel){        
        return this.jpSharedShow.get(jackpotLevel).jackpotElement.GetDuration();
    }


}

